
import Vue from "vue";

export default Vue.extend({
  name: "TextFieldDecimal",
  props: {
    tooltip: String,
    value: [String, Number],
    rules: Array,
    label: String,
    readonly: Boolean,
    disabled: Boolean,
    maxlength: Number,
    required: Boolean,
    digitos: Number,
    placeholder: String,
    hint:{
      type: [String, Number, Object],
      default: ''
    },
    persistent_hint: Boolean,
    modelo: {
      type: Object,
      default: () => {
        return {
          decimal: ",",
          thousands: ".",
          prefix: "",
          suffix: "",
          precision: 2,
          masked: false,
        };
      },
    },
    appendOuterIcon: String,
  },
  data() {
    return {
      valor: null as number | string,
    };
  },
  methods: {
    validarDigito($event) {
      var keyCode = $event.charCode ? $event.charCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    change() {
      this.$emit("change");
    },
    //@ts-ignore
    formatar(valor, opcoes = this.modelo) {
      if (valor) {
        if (typeof valor === "number") {
          valor = valor.toFixed(this.fixed(opcoes.precision));
        }
        var negative = valor.indexOf("-") >= 0 ? "-" : "";

        var numbers = this.onlyNumbers(valor);
        var currency = this.numbersToCurrency(numbers, opcoes.precision);
        var parts = this.toStr(currency).split(".");
        var integer = parts[0];
        var decimal = parts[1];
        integer = this.addThousandSeparator(integer, opcoes.thousands);
        var retorno =
          opcoes.prefix +
          negative +
          this.joinIntegerAndDecimal(integer, decimal, opcoes.decimal) +
          opcoes.suffix;
        return retorno;
      }
    },
    fixed(precision) {
      return this.between(0, precision, 20);
    },
    between(min, n, max) {
      return Math.max(min, Math.min(n, max));
    },
    onlyNumbers(input) {
      return this.toStr(input).replace(/\D+/g, "") || "0";
    },
    toStr(value) {
      return value ? value.toString() : "";
    },
    numbersToCurrency(numbers, precision) {
      var exp = Math.pow(10, precision);
      var float = parseFloat(numbers) / exp;
      return float.toFixed(this.fixed(precision));
    },
    addThousandSeparator(integer, separator) {
      return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
    },
    joinIntegerAndDecimal(integer, decimal, separator) {
      return decimal ? integer + separator + decimal : integer;
    },
    cursorInicio(ev) {
      var el = document.getElementById("txtDecimal");
      //@ts-ignore
      this.setCursor(el, el.value.length, this.modelo.suffix.length);
    },
    setCursor(el, position) {
      var setSelectionRange = function () {
        el.setSelectionRange(position, position);
      };
      if (el === document.activeElement) {
        setSelectionRange();
        setTimeout(setSelectionRange, 1);
      }
    },
  },
  watch: {
    valor: {
      immediate: true,
      handler(val) {
        var varConvertido = 0;
        var numeroFormatado = this.formatar(val, this.modelo);
        //@ts-ignore
        this.valor = numeroFormatado;
        if (val && val != null)
          varConvertido = parseFloat(
            numeroFormatado.toString().replace(/\./g, "").replace(",", ".")
          );

        this.$emit("input", varConvertido);
      },
    },
    value: {
      immediate: true,
      handler(val) {
        var varConvertido = "";
        if (val && val != null) {
          varConvertido = val.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
        //@ts-ignore
        this.valor = varConvertido;
      },
    },
  },
});
